import { render } from "./descript.vue?vue&type=template&id=3d13d88a"
import script from "./descript.vue?vue&type=script&lang=js"
export * from "./descript.vue?vue&type=script&lang=js"

import "./descript.vue?vue&type=style&index=0&id=3d13d88a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/sign-log/advertising-register/step/components/descript.vue'],['render',render],['__file',"descript.vue"]])

export default __exports__